export const SEARCH_PROFILES_PENDING = 'SEARCH_PROFILES_PENDING';
export const SEARCH_PROFILES_SUCCESS = 'SEARCH_PROFILES_SUCCESS';
export const SEARCH_PROFILES_ERROR = 'SEARCH_PROFILES_ERROR';
export const GET_PROFILES_PENDING = 'GET_PROFILES_PENDING';
export const GET_PROFILES_SUCCESS = 'GET_PROFILES_SUCCESS';
export const GET_PROFILES_ERROR = 'GET_PROFILES_ERROR';
export const UPDATE_PROFILE_PENDING = 'UPDATE_PROFILE_PENDING';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
export const CREATE_PROFILE_PENDING = 'CREATE_PROFILE_PENDING';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';
export const CREATE_PROFILE_ERROR = 'CREATE_PROFILE_ERROR';
export const GET_PROFILE_PENDING = 'GET_PROFILE_PENDING';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR';
export const REMOVE_PROFILE_PENDING = 'REMOVE_PROFILE_PENDING';
export const REMOVE_PROFILE_SUCCESS = 'REMOVE_PROFILE_SUCCESS';
export const REMOVE_PROFILE_ERROR = 'REMOVE_PROFILE_ERROR';
export const SET_PROFILE_INDEX_SUCCESS ="SET_PROFILE_INDEX_SUCCESS"
export function getProfilesPending() {
  return { type: GET_PROFILES_PENDING }
};

export function setProfileIndexSuccess(payload) {
  return { type: SET_PROFILE_INDEX_SUCCESS, payload }
};

export function getProfilesSuccess(payload) {
  return { type: GET_PROFILES_SUCCESS, payload }
};

export function getProfilesError(error) {
  return { type: GET_PROFILES_ERROR, error }
};

export function getProfilePending() {
  return { type: GET_PROFILE_PENDING }
};

export function getProfileSuccess(payload) {
  return { type: GET_PROFILE_SUCCESS, payload }
};

export function getProfileError(error) {
  return { type: GET_PROFILE_ERROR, error }
};

export function createProfilePending() {
  return { type: CREATE_PROFILE_PENDING }
};

export function createProfileSuccess(payload) {
  return { type: CREATE_PROFILE_SUCCESS, payload }
};

export function createProfileError(error) {
  return { type: CREATE_PROFILE_ERROR, error }
};

export function updateProfilePending() {
  return { type: UPDATE_PROFILE_PENDING }
};

export function updateProfileSuccess(payload) {
  return { type: UPDATE_PROFILE_SUCCESS, payload }
};

export function updateProfileError(error) {
  return { type: UPDATE_PROFILE_ERROR, error }
};

export function searchProfilesPending() {
  return { type: SEARCH_PROFILES_PENDING }
};

export function searchProfilesSuccess(payload) {
  return { type: SEARCH_PROFILES_SUCCESS, payload }
};

export function searchProfilesError(error) {
  return { type: SEARCH_PROFILES_ERROR, error }
};

export function removeProfilePending() {
  return { type: REMOVE_PROFILE_PENDING }
};

export function removeProfileSuccess(payload) {
  return { type: REMOVE_PROFILE_SUCCESS, payload }
};

export function removeProfileError(error) {
  return { type: REMOVE_PROFILE_ERROR, error }
};
